var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1513_4768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1998 50C99.1998 59.7309 96.3143 69.2432 90.9081 77.3341C85.502 85.425 77.818 91.7311 68.8279 95.4549C59.8377 99.1788 49.9453 100.153 40.4014 98.2547C30.8575 96.3563 22.0909 91.6705 15.2102 84.7897C8.32943 77.909 3.64358 69.1424 1.74519 59.5985C-0.153202 50.0546 0.821122 40.1622 4.54495 31.172C8.26879 22.1819 14.5749 14.4979 22.6658 9.09174C30.7567 3.68558 40.269 0.800049 49.9998 0.800049C63.0485 0.800049 75.5627 5.98361 84.7895 15.2104C94.0163 24.4372 99.1998 36.9514 99.1998 50Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7676 23.2665L47.0746 26.2946L49.6017 16.875L55.2552 18.4091L52.8266 27.4396L57.4379 28.6785L59.8711 19.5497L65.623 21.0883L63.1451 30.2663C63.1451 30.2663 72.5379 32.3462 74.7474 39.9856C76.9569 47.625 69.89 51.637 67.7073 51.7891C67.7073 51.7891 75.9371 56.3021 73.1104 65.1805C70.2836 74.0588 61.6065 75.6466 52.4777 73.6115L49.9998 83.1295L44.2479 81.5909L46.775 72.2205L42.2128 70.9771L39.6857 80.4146L33.9785 78.8804L36.51 69.4877L24.9033 66.3568L27.8285 59.8624C27.8285 59.8624 31.1025 60.7569 32.3415 61.0521C33.5804 61.3473 34.3766 60.0592 34.7254 58.771C35.0743 57.4829 40.3298 36.1346 40.8262 34.3768C41.3227 32.619 41.1214 31.2459 39.0371 30.7047C36.9528 30.1635 34.1171 29.3181 34.1171 29.3181L35.7676 23.2665ZM47.173 51.5386L44.0421 63.9862C44.0421 63.9862 59.567 69.5906 61.5528 61.7051C63.5387 53.8197 47.173 51.5386 47.173 51.5386ZM48.6132 45.6346L51.686 34.2292C51.686 34.2292 64.979 36.6087 63.3419 42.9555C61.7049 49.3023 53.8687 46.8691 48.6132 45.6346Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1513_4768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.4,
    height: 98.4,
    fill: "white",
    transform: "translate(0.799805 0.800049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinIcon);
export default __webpack_public_path__ + "static/media/bitcoin-icon.e75983a3985d44a878b568b22693fdc6.svg";
export { ForwardRef as ReactComponent };